import Home from './Pages/Home';
import About from './Pages/About';
import Contact from './Pages/Contact';
import OurServices from './Pages/OurServices';
import JobCareer from './Pages/JobCareer';
import PrivacyPolicy from "./Pages/PrivacyPolicy";
import TermsConditions from "./Pages/TermsConditions";
import DataDeletion from "./Pages/DataDeletion";

import CandidateForm from "./Components/CandidateForm";
import FinanceSodtDetails from "./Components/FinanceSodtDetails";
import SchoolErpDetails from "./Components/SchoolErpDetails";
import WebsitePage from './Components/WebsitePage';
import CustomApplication from './Components/CustomApplication';
import EcommerceDetails from './Components/EcommerceDetails';

import { Routes, Route, useLocation } from 'react-router-dom';

import Footer from './Components/Footer';
import Header from './Components/Header';
import WhatsAppFloat from './Components/WhatsAppFloat';
import ScrollToTop from './Components/ScrollToTop';
import Blogs from "./Pages/Blogs";
import BlogDetails from "./Pages/BlogDetails";

import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

// Admin
import AdminDashboard from "./admin/AdminDashboard";
import AddBlog from "./admin/AddBlog";
import ManageBlogs from "./admin/ManageBlogs";
import ManageDemoRequests from './admin/ManageDemoRequests';

function App() {

  const location = useLocation();

  // 👉 Hide Header/Footer for Admin Panel
  const isAdminRoute = location.pathname.startsWith("/admin");

  return (
    <>
      {!isAdminRoute && <Header />}

      <div style={{ marginTop: isAdminRoute ? "0px" : "80px" }}>
        <ScrollToTop />

        <Routes>

          {/* ================= WEBSITE ROUTES ================= */}
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/service" element={<OurServices />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/careers" element={<JobCareer />} />
          <Route path="/apply" element={<CandidateForm />} />

          <Route path="/products/school-management" element={<SchoolErpDetails />} />
          <Route path="/products/finance-management" element={<FinanceSodtDetails />} />
          <Route path="/products/website-management" element={<WebsitePage />} />
          <Route path="/products/custom-application" element={<CustomApplication />} />
          <Route path="/products/ecommerce-website" element={<EcommerceDetails />} />

          <Route path="/blogs" element={<Blogs />} />
          <Route path="/blog/:slug" element={<BlogDetails />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/terms-and-conditions" element={<TermsConditions />} />
          <Route path="/data-deletion" element={<DataDeletion />} />

          {/* ================= ADMIN ROUTES ================= */}
          <Route path="/admin" element={<AdminDashboard />}>

            {/* Dashboard Home */}
            <Route index element={
              <div>
                <h3>Welcome to Admin Dashboard</h3>
                <p>Manage blogs and website content from here.</p>
              </div>
            } />

            {/* Blog Pages */}
            <Route path="add-blog" element={<AddBlog />} />
            <Route path="blogs" element={<ManageBlogs />} />
            <Route path="request" element={<ManageDemoRequests />} />

          </Route>

        </Routes>
      </div>

      {!isAdminRoute && <Footer />}
      {!isAdminRoute && <WhatsAppFloat />}

      {/* ✅ ADD THIS */}
     <ToastContainer position="top-right" autoClose={2000} />

    </>
  );
}

export default App;
